export enum Permission {
  PartnerConfigurationsView = 'partner_configurations.view',
  PartnerConfigurationsModify = 'partner_configurations.modify',
}
